import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../../apis/HttpBaseApiWrapper';
import { useAnalyticsService } from '../../../../../apis/analytics/useAnalyticsService';
import {
  StudentPerformanceReview,
  StaffPerformanceReview,
  ExternalPerformanceReview,
  PerformanceSummary,
} from '../performance.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentPerformanceReviewsKey = 'get-student-performance-reviews';
export const getStudentPerformanceSummaryKey = 'get-student-performance-summary';
export const getStaffPerformanceReviewsKey = 'get-staff-performance-reviews';
export const getStaffPerformanceSummaryKey = 'get-staff-performance-summary';
export const getExternalPerformanceReviewsKey = 'get-external-performance-reviews';
export const getExternalPerformanceSummaryKey = 'get-external-performance-summary';

export const useStudentPerformanceReviewsHook = (
  options?: UseQueryOptions<StudentPerformanceReview[], TQueryError>
): UseQueryResult<StudentPerformanceReview[], TQueryError> => {
  const { getStudentPerformanceReviews } = useAnalyticsService();

  return useQuery<StudentPerformanceReview[], TQueryError>({
    queryKey: [getStudentPerformanceReviewsKey],
    queryFn: () => getStudentPerformanceReviews(),
    enabled: true,
    ...options,
  });
};

export const useStudentPerformanceSummaryHook = (
  options?: UseQueryOptions<PerformanceSummary, TQueryError>
): UseQueryResult<PerformanceSummary, TQueryError> => {
  const { getStudentPerformanceSummary } = useAnalyticsService();

  return useQuery<PerformanceSummary, TQueryError>({
    queryKey: [getStudentPerformanceSummaryKey],
    queryFn: () => getStudentPerformanceSummary(),
    enabled: true,
    ...options,
  });
};

export const useStaffPerformanceReviewsHook = (
  options?: UseQueryOptions<StaffPerformanceReview[], TQueryError>
): UseQueryResult<StaffPerformanceReview[], TQueryError> => {
  const { getStaffPerformanceReviews } = useAnalyticsService();

  return useQuery<StaffPerformanceReview[], TQueryError>({
    queryKey: [getStaffPerformanceReviewsKey],
    queryFn: () => getStaffPerformanceReviews(),
    enabled: true,
    ...options,
  });
};

export const useStaffPerformanceSummaryHook = (
  options?: UseQueryOptions<PerformanceSummary, TQueryError>
): UseQueryResult<PerformanceSummary, TQueryError> => {
  const { getStaffPerformanceSummary } = useAnalyticsService();

  return useQuery<PerformanceSummary, TQueryError>({
    queryKey: [getStaffPerformanceSummaryKey],
    queryFn: () => getStaffPerformanceSummary(),
    enabled: true,
    ...options,
  });
};

export const useExternalPerformanceReviewsHook = (
  options?: UseQueryOptions<ExternalPerformanceReview[], TQueryError>
): UseQueryResult<ExternalPerformanceReview[], TQueryError> => {
  const { getExternalPerformanceReviews } = useAnalyticsService();

  return useQuery<ExternalPerformanceReview[], TQueryError>({
    queryKey: [getExternalPerformanceReviewsKey],
    queryFn: () => getExternalPerformanceReviews(),
    enabled: true,
    ...options,
  });
};

export const useExternalPerformanceSummaryHook = (
  options?: UseQueryOptions<PerformanceSummary, TQueryError>
): UseQueryResult<PerformanceSummary, TQueryError> => {
  const { getExternalPerformanceSummary } = useAnalyticsService();

  return useQuery<PerformanceSummary, TQueryError>({
    queryKey: [getExternalPerformanceSummaryKey],
    queryFn: () => getExternalPerformanceSummary(),
    enabled: true,
    ...options,
  });
};
